import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { estimateImpact } from "../impact";

const inr = (n) => `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const kg = (n) => n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Running estimates that grow second by second: CO2 absorbed by the planted
// trees and the fruit income they have earned the farmers, since planting.
function LiveImpact({ treesByYear }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 250);
    return () => clearInterval(timer);
  }, []);

  const i = estimateImpact(treesByYear || {}, now);
  if (!i.plantedTrees) return null;

  return (
    <div className="mt-5 border-t border-sritaru-100 pt-4">
      <div className="flex items-center justify-center gap-2 mb-3">
        <span className="inline-block bg-earth-100 text-earth-700 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded">
          Live estimate
        </span>
        <span className="text-[11px] text-gray-500">calculated from tree age and growth rates, not measured</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="bg-sritaru-50 rounded-lg p-3 text-center">
          <p className="text-xs text-gray-600">🌍 CO₂ absorbed so far</p>
          <p className="text-2xl font-bold text-sritaru-700 tabular-nums">{kg(i.co2ToDateTonnes * 1000)} kg</p>
          <p className="text-[11px] text-gray-500">
            ≈ {i.co2ToDateTonnes.toFixed(1)} tonnes · now about {Math.round(i.co2PerYearNowTonnes)} t a year
          </p>
        </div>
        <div className="bg-sritaru-50 rounded-lg p-3 text-center">
          <p className="text-xs text-gray-600">🧑‍🌾 Fruit income earned by farmers so far</p>
          <p className="text-2xl font-bold text-sritaru-700 tabular-nums">{inr(i.incomeToDateInr)}</p>
          <p className="text-[11px] text-gray-500">
            now about ₹{(i.incomeThisYearInr / 1e5).toFixed(1)} lakh a year, rising to ₹{(i.incomeAtMaturityInr / 1e7).toFixed(2)} crore as trees mature
          </p>
        </div>
      </div>
      <p className="text-center mt-2">
        <Link to="/farms" className="text-[11px] text-sritaru-700 underline">How we estimate these, and our farms from space →</Link>
      </p>
    </div>
  );
}

export default LiveImpact;
